import { render, staticRenderFns } from "./BackgroundDust.vue?vue&type=template&id=17af5de6&scoped=true&"
import script from "./BackgroundDust.vue?vue&type=script&lang=js&"
export * from "./BackgroundDust.vue?vue&type=script&lang=js&"
import style0 from "./BackgroundDust.vue?vue&type=style&index=0&id=17af5de6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17af5de6",
  null
  
)

component.options.__file = "BackgroundDust.vue"
export default component.exports